import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getChildrenPrivacyPolicy } from '#/redux/modules/accedoOne/selectors';
import { loadChildrenPrivacyPolicy } from '#/redux/modules/accedoOne/actions';
import { parentZone } from '#/config/strings';
import kidSafe from '#/static/images/icons/sensical_small_kidSafe.svg';
import styles from './ChildrenPrivacyPolicyModal.scss';

const ChildrenPrivacyPolicyModal = () => {
  const dispatch = useDispatch();
  const content = useSelector(getChildrenPrivacyPolicy);
  const contentAreaRef = useRef(null);

  useEffect(() => {
    if (!content) {
      dispatch(loadChildrenPrivacyPolicy);
    }
    contentAreaRef?.current?.focus();
  }, []);

  return (
    <>
      <h2 className={(styles.title, styles.modalTitle)}>
        {parentZone.childrenPrivacyPolicy}
      </h2>
      <div className={styles.kidImg}>
        <img src={kidSafe} alt="Kid Safe" />
      </div>
      <p ref={contentAreaRef} tabIndex={0} className={styles.textContent}>
        {content}
      </p>
    </>
  );
};

export default ChildrenPrivacyPolicyModal;
